import { render, staticRenderFns } from "./ChargeCurrencyTotalGroup.vue?vue&type=template&id=bdbfec86&scoped=true&"
import script from "./ChargeCurrencyTotalGroup.vue?vue&type=script&lang=js&"
export * from "./ChargeCurrencyTotalGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbfec86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdbfec86')) {
      api.createRecord('bdbfec86', component.options)
    } else {
      api.reload('bdbfec86', component.options)
    }
    module.hot.accept("./ChargeCurrencyTotalGroup.vue?vue&type=template&id=bdbfec86&scoped=true&", function () {
      api.rerender('bdbfec86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue"
export default component.exports